export default "__VITE_ASSET__0JGGAuaV__"